import { render, staticRenderFns } from "./HeaderSpineSymposium.vue?vue&type=template&id=b08f87f0&"
import script from "./HeaderSpineSymposium.vue?vue&type=script&lang=js&"
export * from "./HeaderSpineSymposium.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSpineSymposium.vue?vue&type=style&index=0&id=b08f87f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports